import { render, staticRenderFns } from "./DerivedDataBadge.vue?vue&type=template&id=5ecdf69a&scoped=true"
import script from "./DerivedDataBadge.vue?vue&type=script&lang=js"
export * from "./DerivedDataBadge.vue?vue&type=script&lang=js"
import style0 from "./DerivedDataBadge.vue?vue&type=style&index=0&id=5ecdf69a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecdf69a",
  null
  
)

export default component.exports